<template>
	<div id="service2">
		<Menu areWeinServices="true" selectedRoute="secLogistics"/>
		<!-- Header Inicio :style="{ backgroundImage: 'url(' + firstImage + ')' }" -->
		<div class="colorAzul">
			<section class="secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
				<div class="fondotransparenteServicio">
					<h1>{{title}}</h1>
				</div>
			</section>

			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">We have the capacity to scale to handle large events and productions securely, professionally and smoothly</h2>
						<p class="parrafoContenidoInterno">Our tight-knit team has long years of experience supporting large sporting events for major professional leagues and large broadcasters in the main arenas and stadiums of the capital. We work hand in hand with the security leadership of our clients to ensure that major operations proceed smoothly.</p>
						<ul class="listaContenidoInterno">
							<li>Requirement planning, logistics, resource procurement</li>
							<li>Coordination with airport authorities for VIP processing</li>
							<li>Coordination with mounted police units</li>
							<li>Bilingual team leads and agents</li>
							<li>Supplementary security at major hotels or recreation venues</li>
							<li>Armored executive vehicles and escort vehicles</li>
							<li>Rapid Response Center 24x7x365</li>
						</ul>

						<p class="parrafoContenidoInterno">
							We tend in a professional and expert manner to our clients’ requirements, both in commute logistic planning, and during the commute itself, through our Service and Instant Reaction Center (SRIC).
							<br>
							<br>
							<span>Grupo Glarus</span> has expert people on logistics, bilingual drivers and security personnel to make a proper operation and deliverance of our mobility service for transporting people and equipment.
						</p>
					</div>

					<cuadro/>

					<!-- cuadro -->
				</div>
			</section>

			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>{{titleIcons}}</span>
					</h1>

					<div class="gridIcons">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/4_seguridad.jpg";
import imagen2 from "@/assets/img/servicios/2/second_.jpg";
import icono01 from "@/assets/img/servicios/1/01.png";
import icono02 from "@/assets/img/servicios/2/02.png";
import icono03 from "@/assets/img/servicios/1/03.png";
import icono04 from "@/assets/img/servicios/1/04.png";

export default {
	name: "servicio02",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title =
				"Glarus Group - Security Logistics for Events and Productions in Mexico";
		});
	},
	data: function() {
		return {
			title: "SECURITY LOGISTICS FOR EVENTS AND PRODUCTIONS IN MEXICO",
			subtitle: "Security logistics for events and productions",
			thirdTitle: "Punctuality and security for special events.",
			firstImage: imagen1,
			secondImage: imagen2,
			titleIcons: "We Provide",

			precautions: [
				{
					id: "4",
					icon: icono04,
					altIcon: "glarus service 4",
					descripcion: "Analysis, Logistics and Resource Procurement"
				},
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 1",
					descripcion: "Trained bilingual drivers and security agents"
				},
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 2",
					descripcion: "Sprinter Vehicles and Passenger Buses"
				},
				{
					id: "3",
					icon: icono03,
					altIcon: "glarus service 3",
					descripcion: "Rapid Response Center 24x7x365"
				},
			]
		};
	}
};
</script>

<style lang="less">
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
